// https://stackoverflow.com/questions/38460949/what-is-the-best-way-to-access-redux-store-outside-a-react-component
import { configureStore, Middleware } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import createSagaMiddleware from 'redux-saga';
import { createLogger } from 'redux-logger';
import type { AppState } from '~/reducers';
import rootReducer from '~/reducers/root-reducer';
import rootSaga from '~/sagas/root-saga';
import checkLoggingVar from '~/utils/env-helpers/check-use-logging-variable';
import { bffWebApi } from '~/api';

export function makeStore(useLogger = true, initialState?: Partial<AppState>) {
  const sagaMiddleware = createSagaMiddleware();
  const middleWares: Middleware[] = [sagaMiddleware, bffWebApi.middleware];

  if (useLogger && checkLoggingVar()) {
    middleWares.push(
      createLogger({
        collapsed: true,
        duration: true,
      })
    );
  }

  // TODO: when all records are removed from the state, remove the 'serializableCheck' exception.
  const store = configureStore({
    reducer: rootReducer,
    middleware: (gdm) =>
      gdm({ serializableCheck: false, immutableCheck: false }).concat(middleWares),
    preloadedState: initialState,
    devTools: true,
  });

  sagaMiddleware.run(rootSaga);
  setupListeners(store.dispatch);
  return store;
}

export type AppStore = ReturnType<typeof makeStore>;
export type AppDispatch = AppStore['dispatch'];
export type RootState = ReturnType<AppStore['getState']>;

export default makeStore();
